/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../../components/layout-components/Layout";
import SPPContainer from "../../components/page-sections/singleproperty/SPPContainer";
import GetInTouch from "../../components/page-sections/singleproperty/GetInTouch";

/* Data Imports */

import AppConfig from "../../AppConfig";

/* Redux Imports */

import { createStore, applyMiddleware } from "redux";
import GlobalReducer from "../../components/redux-components/GlobalReducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

/* Create Redux Store */

const reduxStore = createStore(GlobalReducer, applyMiddleware(thunk));

export const getStaticPaths = async () => ({
  paths: await (
    await (
      await fetch(AppConfig.apiUrlPrefix + "properties/all-property-slugs")
    ).json()
  ).map((slugObject) => ({
    params: slugObject,
  })),
  fallback: false,
});

export const getStaticProps = async ({ params }) => {
  /* Delay each API call by 250ms so Vercel doesn't assume it's a DDOS attack and builds succeed without multiple tries */

  await setTimeout[Object.getOwnPropertySymbols(setTimeout)[0]](250);

  /* Prepare data for each page */

  const returnData = {
    props: {
      propertyData: await (
        await fetch(AppConfig.apiUrlPrefix + "properties/" + params.slug)
      ).json(),
      slug: params.slug,
    },
  };
  return returnData;
};

const SingleProperty = (props) => {
  const { propertyData, slug } = props;
  return (
    <Provider store={reduxStore}>
      <React.Fragment>
        <Layout
          keywords={
            propertyData
              ? propertyData.property.seo.keywords.join()
              : "lighter,advisory,real,estate,advisory,pwa,next,property,bangalore,bengaluru,home,house,apartment,land,plot,rent,buy,sell,agriculture,farm,construction,architect,architecture,interior,design,material,ui,township,react"
          }
          description={
            propertyData
              ? propertyData.property.seo.meta_description
              : "Lighter Advisory is a real estate advisory and marketing firm"
          }
          title={
            propertyData
              ? propertyData.property.seo.meta_title
              : "Lighter Advisory"
          }
          // jsonLDSchema={{
          //   __html: JSON.stringify({
          //     "@context": "https://schema.org/",
          //     "@type": "RealEstateListing",
          //     name: "Party Coffee Cake",
          //     author: {
          //       "@type": "Person",
          //       name: "Mary Stone",
          //     },
          //     datePublished: "2018-03-10",
          //     description:
          //       "This coffee cake is awesome and perfect for parties.",
          //   }),
          // }}
        >
          <SPPContainer
            defaultPropertyData={propertyData.property}
            defaultFeaturedPropertiesData={propertyData.featured}
            currentSlug={slug}
          />
          <GetInTouch data={{ loading: "default" }} />
        </Layout>
      </React.Fragment>
    </Provider>
  );
};

export default SingleProperty;
